import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";

interface StoryBoardProps {
  storyboard: AnalysisResult["storyboard_analysis"];
}

const StoryBoard = ({ storyboard }: StoryBoardProps) => {
  return (
    <div className="space-y-4">
      {/* Artist Notes */}
      <div className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30">
        <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
          Artist Notes
        </h4>
        <p className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
          {storyboard.artist_notes || "N/A"}
        </p>
      </div>

      {/* Technical Breakdown */}
      <div className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30">
        <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
          Technical Breakdown
        </h4>
        <div className="mt-3 space-y-2">
          {storyboard.technical_summary_breakdown &&
            Object.entries(storyboard.technical_summary_breakdown).map(
              ([key, value]) => (
                <div key={key} className="space-y-1">
                  <h6 className="text-[#0D0D0D80] text-[10px] leading-[120%] tracking-[0%] capitalize">
                    {key.replace(/_/g, " ")}
                  </h6>
                  <p className="text-[#0D0D0D] text-[10px] leading-[120%] tracking-[0%] font-medium">
                    {value || "N/A"}
                  </p>
                </div>
              )
            )}
        </div>
      </div>

      {/* Overview */}
      <div className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30">
        <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
          Overview
        </h4>
        <p className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
          {storyboard.storyboard_description || "N/A"}
        </p>
      </div>

      {/* Technical Summary */}
      <div className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30">
        <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
          Technical Summary
        </h4>
        <p className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
          {storyboard.technical_summary || "N/A"}
        </p>
      </div>
    </div>
  );
};

export default StoryBoard;
